<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :router="{
      name: 'ORGANIZATION_LIST',
    }"
  >
    <el-form
      status-icon
      :model="ruleForm"
      :rules="rules"
      label-position="top"
      ref="ruleForm"
      label-width="120px"
      class="carpo-form demo-ruleForm"
    >
      <el-form-item :label="$t('TITLE')" prop="title">
        <el-input
          :disabled="ruleForm.disabled"
          type="text"
          v-model="ruleForm.title"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="`${$t('SUBSET')}`"
        prop="parent"
        v-loading="organizationsLoading"
        element-loading-spinner="el-icon-loading"
      >
        <el-select
          :disabled="ruleForm.disabled"
          v-model="ruleForm.parent"
          clearable
          :collapse-tags="!ruleForm.disabled"
          filterable
          :placeholder="$t('SELECT_PLACEHOLDER')"
        >
          <el-option
            v-for="item in organizationsList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        :label="`${$t('USERS')}`"
        prop="users"
        v-loading="usersListLoading"
        element-loading-spinner="el-icon-loading"
      >
        <el-select
          :disabled="ruleForm.disabled"
          v-model="ruleForm.users"
          clearable
          multiple
          :collapse-tags="!ruleForm.disabled"
          filterable
          :placeholder="$t('SELECT_PLACEHOLDER')"
        >
          <el-option
            v-for="item in userList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <FormConfirmation
        v-show="!ruleForm.disabled"
        @resetForm="resetForm('ruleForm')"
        @submitForm="submitForm('ruleForm')"
        :edit="null"
        :loading="submitLoading"
      />
    </el-form>
  </Content>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import {
  addOrganization,
  editOrganization,
  usersListSummary,
  organizationSummaryList,
} from '@/api/acl'

export default {
  props: ['organization'],
  watch: {
    organization(val) {
      this.ruleForm = val
    },
  },
  mixins: [resetForm],
  components: {
    FormConfirmation,
  },
  data() {
    return {
      addTag: false,
      submitLoading: false,
      organizationsList: [],
      organizationsLoading: true,
      userList: [
        {
          label: '',
          value: '',
        },
      ],
      usersListLoading: true,
      ruleForm: {
        title: '',
        users: [],
        parent: '',
      },

      rules: {
        title: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('TITLE'),
            }),
            trigger: 'blur',
          },
        ],

        parent: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('SUBSET'),
            }),
            trigger: 'change',
          },
        ],
      },
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            title: this.ruleForm.title,
            parent: this.ruleForm.parent,
            users: this.ruleForm.users,
            id: this.organization != undefined ? this.organization.id : '',
          }
          var dispatchFunc =
            this.organization == null ? addOrganization : editOrganization

          this.submitLoading = true
          dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.$notify.success({
                title:
                  this.$t(this.$route.name) +
                  ' ' +
                  this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
              if (this.organization == null) this.resetForm(formName)
              else
                this.$router.push({
                  name: 'ORGANIZATION_LIST',
                })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  mounted() {
    usersListSummary.api().then((res) => {
      if (res) {
        this.userList = res.map((i) => {
          return {
            value: i.id,
            label: i.username,
          }
        })

        this.usersListLoading = false
      }
    })
    organizationSummaryList.api().then((res) => {
      if (res) {
        this.organizationsList = res.map((i) => {
          return {
            value: i.id,
            label: i.title,
          }
        })

        this.organizationsLoading = false
      }
    })
  },
}
</script>
